import React from 'react';

const PhiSymbol = () => {
	return (
		<>
			<div className="phi-symbol">&#8709;</div>
		</>
	);
};

export default PhiSymbol;
